import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IconComponent } from '../icon/icon.component';
import { SortOption } from '../../utils/course-sort-filter.utils';

@Component({
  selector: 'app-course-filter-bar',
  standalone: true,
  imports: [CommonModule, FormsModule, IconComponent],
  templateUrl: './course-filter-bar.component.html',
  styleUrls: ['./course-filter-bar.component.scss']
})
export class CourseFilterBarComponent {
  @Input() searchTerm = '';
  @Input() sortField = 'title';
  @Input() sortOrder: 'asc' | 'desc' = 'asc';
  @Input() sortOptions: SortOption[] = [];
  @Input() showSearch = true;
  @Input() resultCount = 0;
  @Input() totalCount = 0;

  @Output() searchTermChange = new EventEmitter<string>();
  @Output() sortChange = new EventEmitter<{ field: string; order: 'asc' | 'desc' }>();

  onSearchInput(value: string): void {
    this.searchTermChange.emit(value);
  }

  onSortFieldChange(field: string): void {
    this.sortChange.emit({ field, order: this.sortOrder });
  }

  toggleSortOrder(): void {
    const newOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    this.sortChange.emit({ field: this.sortField, order: newOrder });
  }

  get isFiltered(): boolean {
    return this.searchTerm?.trim().length > 0;
  }

  clearSearch(): void {
    this.searchTermChange.emit('');
  }
}
